import { render } from "./BaseLinkedinCompany.vue?vue&type=template&id=47cea6e6"
import script from "./BaseLinkedinCompany.vue?vue&type=script&lang=js"
export * from "./BaseLinkedinCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__